import { requestsReducer } from 'redux-saga-requests';
import { GET_REPORTS } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const getReportsReducer = requestsReducer({
  actionType: GET_REPORTS,
  multiple: true,
  getData: (state, action) => action.payload.data.content,
});
